import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-login',
  templateUrl:
    './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginData = { loginId: '', password: '' };
  errorMessage = '';
  tabs = ['Instructions', 'About Simulation', 'About Company', 'FAQ', 'Contact'];
  selectedTab = 'Instructions';

  constructor(private authService: AuthService, private router: Router,private toaster: ToastrService) { }

  selectTab(tab: string) {
    this.selectedTab = tab;
  }

  ngOnInit() { 
     this.loginData = {
    loginId: '',
    password: ''
  };
  }

  onLogin() {
    this.authService.login(this.loginData.loginId, this.loginData.password)
      .subscribe({
        next: (response) => {
          if (response?.errorCode === '000000') {
            this.toaster.success('Login successful', 'Success');
            if (response?.Data?.token) {
              this.authService.saveToken(response.Data.token);

              const userlogged = {
                userId: response.Data.userId,
                username: response.Data.username,
                loginid: response.Data.loginid,
                userType: response.Data.userType,
                userStatus: response.Data.userStatus,
                userBatch: response.Data.userBatch
              };

              this.authService.saveUser(userlogged);

              if (userlogged.userType === 'admin') {
                this.router.navigate(['admin-dashboard']);
              }
              else if (userlogged.userType === 'faculty') {
                this.router.navigate(['faculty-dashboard']);
              }
              else if (userlogged.userType === 'player') {
                this.router.navigate(['player-dashboard']);
              }
            }

          } else {
            this.errorMessage = response?.errorDescription || "Invalid login credentials";
          }
        },
        error: (err) => {
          console.error('HTTP Error:', err);
        this.errorMessage = err?.error?.message || "Server unavailable. Please try again later.";
        }
      });
  }


}
